export default __webpack_public_path__ + "static/media/whale-word.e22f5a99.png";